import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const processAuth = useCallback(async () => {
    try {
      // Extract session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error('فشل تسجيل الدخول بـ Google');
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];
      
      // Check if this is a link operation (user is already logged in)
      const existingToken = localStorage.getItem('token');
      
      if (existingToken) {
        // User is linking Google account
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/link-google?session_id=${sessionId}`,
          {},
          { headers: { Authorization: `Bearer ${existingToken}` } }
        );
        
        // Update stored user data
        localStorage.setItem('user', JSON.stringify(response.data.user));
        toast.success('تم ربط حساب Google بنجاح ✓');
        navigate('/dashboard');
      } else {
        // Normal Google login
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/google/session?session_id=${sessionId}&platform=cloudgm`
        );
        
        // Store auth data
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        toast.success('تم تسجيل الدخول بنجاح ✓');
        
        // Navigate to home with user data
        navigate('/', { replace: true });
        window.location.reload();
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'فشل تسجيل الدخول');
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    processAuth();
  }, [processAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-[#1E9BD9] mx-auto mb-4" />
        <p className="text-lg text-[#475569]">جاري تسجيل الدخول...</p>
      </div>
    </div>
  );
}
